
/**
 * 강의 콘텐츠 지원 플랫폼
 */
export type CourseDetailSectionLecturesItemPlatformSupport = typeof CourseDetailSectionLecturesItemPlatformSupport[keyof typeof CourseDetailSectionLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDetailSectionLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
  UNKNOWN: 'UNKNOWN',
} as const;
